module.exports = __webpack_public_path__ + "media/16/edit-solid-4ffe848a.svg";